module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/column-square/copper.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/column-square/copper.jpg
// module id = 543
// module chunks = 0